import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  games: [],
};

const versusGamesSlice = createSlice({
  name: "versusGames",
  initialState,
  reducers: {
    setVersusGames(state, action) {
      state.games = action.payload;
    },
    appendVersusGames(state, action) {
      state.games = [...state.games, ...action.payload];
    },
    clearVersusGames(state) {
      state.games = [];
    },
  },
});

export const { setVersusGames, appendVersusGames, clearVersusGames } =
  versusGamesSlice.actions;

export default versusGamesSlice.reducer;
